// extracted by mini-css-extract-plugin
module.exports = {"like":"_vh","active":"_vi","text":"_vj"};